import { afterNextRender, Component, inject, OnInit } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { PublicAppSection } from '../../store/ui/ui.state';
import { Store } from '@ngrx/store';
import { fromStore } from '../../store';
import { LocalizedUrlService } from '../../services/localized-url.service';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="container pt-10 text-center md:pt-20">
      <div class="mx-auto w-80 md:w-96">
        <dotlottie-wc
          autoplay
          loop
          src="/assets/img/404.json"
        ></dotlottie-wc>
      </div>
      <div class="text-center">
        <div class="-mt-8 text-6xl font-bold uppercase md:text-8xl">
          {{ 'common.not-found.title' | transloco }}
        </div>
        <div class="mt-4 text-lg font-bold uppercase md:text-2xl">
          {{ 'common.not-found.message' | transloco }}
        </div>
        <div class="mt-8">
          <app-button
            variant="primary"
            icon="arrow-left"
            [routerLink]="backLink$ | async"
          >
            {{ 'common.button.back' | transloco }}
          </app-button>
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class NotFoundPageComponent implements OnInit {
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendorSlug$: Observable<string> = this.store.select(
    fromStore.selectVendorSlug,
  );
  private localizedUrlService = inject(LocalizedUrlService);

  // Lien de retour localisé : page du vendor en B2C, accueil sinon
  backLink$: Observable<string[]> = combineLatest([
    this.B2C$,
    this.vendorSlug$,
  ]).pipe(
    map(([isB2C, vendorSlug]) =>
      isB2C && vendorSlug
        ? this.localizedUrlService.link('vendor', { vendorSlug })
        : this.localizedUrlService.link('home'),
    ),
  );

  constructor(private store: Store) {
    afterNextRender(() => {
      import('@lottiefiles/dotlottie-wc');
    });
  }

  ngOnInit(): void {}
}
